/**
 * Système de logging structuré pour l'application
 * 
 * Gère les logs en développement et production avec différents niveaux
 * En production, envoie les erreurs critiques à un service de tracking
 */

const LOG_LEVELS = {
  DEBUG: 0,
  INFO: 1,
  WARN: 2,
  ERROR: 3
}

const CURRENT_LOG_LEVEL = process.env.NODE_ENV === 'production' ? LOG_LEVELS.WARN : LOG_LEVELS.DEBUG

/**
 * Formate un message de log avec contexte
 */
function formatLog(level, message, context = {}) {
  const timestamp = new Date().toISOString()
  const contextStr = Object.keys(context).length > 0 
    ? ` ${JSON.stringify(context)}` 
    : ''
  
  return `[${timestamp}] [${level}] ${message}${contextStr}`
}

/**
 * Logger principal
 */
export const logger = {
  debug: (message, context) => {
    if (CURRENT_LOG_LEVEL <= LOG_LEVELS.DEBUG) {
      console.debug(formatLog('DEBUG', message, context))
    }
  },

  info: (message, context) => {
    if (CURRENT_LOG_LEVEL <= LOG_LEVELS.INFO) {
      console.info(formatLog('INFO', message, context))
    }
  },

  warn: (message, context) => {
    if (CURRENT_LOG_LEVEL <= LOG_LEVELS.WARN) {
      console.warn(formatLog('WARN', message, context))
    }
  },

  error: (message, error, context = {}) => {
    const errorContext = {
      ...context,
      error: error?.message,
      stack: error?.stack,
      status: error?.status,
      details: error?.details
    }

    // Toujours logger les erreurs
    console.error(formatLog('ERROR', message, errorContext))

    // En production, envoyer à un service de tracking (Sentry, etc.)
    if (process.env.NODE_ENV === 'production') {
      // TODO: Intégrer avec Sentry ou un autre service de tracking
      // if (window.Sentry) {
      //   window.Sentry.captureException(error, {
      //     tags: context,
      //     extra: errorContext
      //   })
      // }
      
      // Log vers un service de monitoring
      if (typeof window !== 'undefined' && window.gtag) {
        window.gtag('event', 'exception', {
          description: message,
          fatal: false,
          ...errorContext
        })
      }
    }
  }
}

// Note: useNetworkStatus hook est dans src/hooks/useNetworkStatus.js pour éviter les dépendances React dans les utils

